module.exports = __webpack_public_path__ + "img/thumbnails-4-exchange-rate.0a6854e8.png";